import _ from 'lodash';

export const addPoint = (x, y, icon, pointsData) => {
    const points = _.cloneDeep(pointsData);
    let isAdded = false;
    for (let i = 0, len = points.length; i < len; i++) {
        if (points[i].x === x) {
            points[i].y = y;
            if (icon)
                points[i].icon = icon;
            isAdded = true;
            break;
        } else if (points[i].x > x) {
            points.splice(i, 0, { x, y, icon });
            isAdded = true;
            break;
        }
    }
    if (!isAdded) {
        points.push({ x, y, icon });
    }
    return points;
};


export const deletePoint = (x, y, pointsData) => {
    const points = _.cloneDeep(pointsData);
    const index = points.findIndex(d => d.x === x && d.y === y);
    if (index >= 0) {
        points.splice(index, 1);
        return points;
    }
    else
        return pointsData;
};

export function convertHearingLoss(loss) {
    if (!loss) return [];
    return loss.map(d => ({ x: d.x, y: d.y }));
}

export function arrayLast(arr) {
    return arr[arr.length - 1];
}

export const SUPPOER_LOCALES = [
    
    { name: 'English', value: 'en-US', remark: '美国 / 英国 / 澳大利亚 / 加拿大 / 全球通用' },
    { name: '日本語', value: 'ja-JP', remark: '日本（全球最老龄化国家之一）' },
    { name: 'Deutsch', value: 'de-DE', remark: '德国 / 奥地利 / 瑞士（高端医疗市场）' },
    { name: 'Français', value: 'fr-FR', remark: '法国 / 比利时 / 瑞士 / 加拿大魁北克' },
    { name: 'Italiano', value: 'it-IT', remark: '意大利（老龄化严重）' },
    { name: 'Español', value: 'es-ES', remark: '西班牙（老龄化 + 欧洲市场）' },
    { name: '한국어', value: 'ko-KR', remark: '韩国（快速老龄化）' },
    { name: 'Nederlands', value: 'nl-NL', remark: '荷兰 / 比利时（高收入）' },
    { name: 'Svenska', value: 'sv-SE', remark: '瑞典（高福利医疗）' },
    { name: 'Dansk', value: 'da-DK', remark: '丹麦（助听器产业强国）' },
    { name: 'Norsk', value: 'nb-NO', remark: '挪威（高收入国家）' },
    { name: 'Suomi', value: 'fi-FI', remark: '芬兰（北欧高龄社会）' },
    
    { name: '简体中文', value: 'zh-CN', remark: '中国大陆（人口巨大，老龄化快速）' },
    { name: '繁體中文', value: 'zh-TW', remark: '台湾（高收入医疗体系）' },
    { name: 'Português', value: 'pt-PT', remark: '葡萄牙 / 巴西（巴西市场大）' },
    { name: 'Polski', value: 'pl-PL', remark: '波兰（东欧最大经济体之一）' },
    { name: 'Čeština', value: 'cs-CZ', remark: '捷克（中欧高收入）' },
    { name: 'Magyar', value: 'hu-HU', remark: '匈牙利' },
    { name: 'Ελληνικά', value: 'el-GR', remark: '希腊（老龄化明显）' },
    { name: 'Türkçe', value: 'tr-TR', remark: '土耳其（区域大市场）' },
    { name: 'Русский', value: 'ru-RU', remark: '俄罗斯 / 东欧 / 中亚' },
    { name: 'Română', value: 'ro-RO', remark: '罗马尼亚' },
    { name: 'Slovenčina', value: 'sk-SK', remark: '斯洛伐克' },
    { name: 'Български', value: 'bg-BG', remark: '保加利亚' },
    
    { name: 'العربية', value: 'ar-SA', remark: '沙特 / 海湾国家（高收入）' },
    { name: 'עברית', value: 'he-IL', remark: '以色列（医疗技术强）' },
    { name: 'ภาษาไทย', value: 'th-TH', remark: '泰国（医疗旅游强）' },
    { name: 'Bahasa Melayu', value: 'ms-MY', remark: '马来西亚' },
    { name: 'Bahasa Indonesia', value: 'id-ID', remark: '印度尼西亚（人口大）' },
    { name: 'Tiếng Việt', value: 'vi-VN', remark: '越南（增长快）' },
    { name: 'Filipino', value: 'tl-PH', remark: '菲律宾' },
    { name: 'فارسی', value: 'fa-IR', remark: '伊朗' },
    { name: 'Українська', value: 'uk-UA', remark: '乌克兰' },
    
    { name: 'हिन्दी', value: 'hi-IN', remark: '印度北部（人口巨大）' },
    { name: 'বাংলা', value: 'bn-BD', remark: '孟加拉 / 印度东部' },
    { name: 'தமிழ்', value: 'ta-IN', remark: '印度南部 / 斯里兰卡' },
    { name: 'తెలుగు', value: 'te-IN', remark: '印度安得拉邦' },
    { name: 'मराठी', value: 'mr-IN', remark: '印度马哈拉施特拉邦' },
    { name: 'ગુજરાતી', value: 'gu-IN', remark: '印度古吉拉特邦' },
    { name: 'ਪੰਜਾਬੀ', value: 'pa-IN', remark: '印度旁遮普' },
    { name: 'اُردُو', value: 'ur-PK', remark: '巴基斯坦' },
    { name: 'Basa Jawa', value: 'jv-ID', remark: '印尼爪哇岛' },
    
    { name: 'Kiswahili', value: 'sw-KE', remark: '东非（肯尼亚 / 坦桑尼亚）' },
    { name: 'Hausa', value: 'ha-NE', remark: '西非（尼日利亚北部）' },
    { name: 'አማርኛ', value: 'am-ET', remark: '埃塞俄比亚' },
    { name: 'မြန်မာ', value: 'my-MM', remark: '缅甸' },
    { name: 'ភាសាខ្មែរ', value: 'km-KH', remark: '柬埔寨' },
    { name: 'ລາວ', value: 'lo-LA', remark: '老挝' },
    { name: 'العربية المصرية', value: 'ar-EG', remark: '埃及（人口大）' },
    { name: 'Azərbaycan dili', value: 'az-AZ', remark: '阿塞拜疆' }
];

let timer;
export function delay(callback, timeout = 300) {
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
        callback();
        timer = null;
    }, timeout);
}